import { injectable, inject } from "tsyringe";
import { StudentDto } from "@/entities/user/models/dtos";

import type { UserItemProps } from "@/pages/ai-tutor/models/interface";
import type { IDateAdapter } from "@/shared/libs/date/interface";

export interface UserItemConverterStructure {
    convert(studentDtos: StudentDto[]): Omit<UserItemProps, "selected">[];
}

@injectable()
export class UserItemConverter implements UserItemConverterStructure {
    constructor(@inject("DateAdapter") private readonly dateAdapter: IDateAdapter) {}

    public convert = (studentDtos: StudentDto[]): Omit<UserItemProps, "selected">[] => {
        return studentDtos.map((studentDto) => {
            const userItemProps: Omit<UserItemProps, "selected"> = {
                id: studentDto.id,
                name: studentDto.name,
                className: studentDto.class?.name ?? "기본반",
                createdAt: "-",
            };

            if (studentDto.connectedAt) {
                userItemProps.createdAt = this.dateAdapter.formatRelativeDateIn24Hours(
                    studentDto.connectedAt,
                    "Asia/Seoul",
                );
            }

            return userItemProps;
        });
    };
}
